var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Lite_coin"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lite_coin",
    "data-name": "Lite coin",
    clipPath: "url(#clip-Lite_coin)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51",
    transform: "translate(-2.654 -2.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(2.654 2.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    rx: 7,
    fill: "#2980ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,7A7,7,0,0,1,7,0h6.658a16.541,16.541,0,0,1,.824,5.172A16.555,16.555,0,0,1,0,21.6Z",
    transform: "translate(0 0)",
    fill: "#4893ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M179.458,150.154l1.747-.529a.588.588,0,0,1-.015.064c-.113.389-.227.778-.338,1.167a.1.1,0,0,1-.088.076c-.553.156-1.1.314-1.66.469a.09.09,0,0,0-.07.071q-.553,1.872-1.108,3.743a.483.483,0,0,0-.011.05h.073q3,0,6.01,0a.334.334,0,0,1,.331.447c-.167.6-.342,1.189-.515,1.783a.4.4,0,0,1-.409.306h-9.359c.523-1.783,1.043-3.557,1.566-5.34l-1.75.53c.008-.031.012-.05.018-.068q.181-.555.36-1.109a.107.107,0,0,1,.08-.077c.549-.165,1.1-.332,1.645-.5a.081.081,0,0,0,.064-.064q1.092-3.713,2.184-7.425a.412.412,0,0,1,.428-.319h2.322a.337.337,0,0,1,.337.458q-.552,1.892-1.111,3.781l-.715,2.432C179.467,150.112,179.465,150.126,179.458,150.154Z",
    transform: "translate(-161.449 -132.959)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.f653fbed5d9735746e712c0b02ac84d2.svg";
export { ForwardRef as ReactComponent };